import axios from '@/api/axios.config'
import { getAssetsSchema } from '@messenger/types'
import type { GetAssetsNormalized } from '@messenger/types'
import { z } from 'zod'

export const getAssetsByName = async (
  name: z.infer<typeof getAssetsSchema>['name'],
) => {
  return await axios.get<{ assets: GetAssetsNormalized[] }>(
    `/assets?name=${name}`,
  )
}
